import "./Parametre.css";
import React from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { UpdatePassword } from "../../Auth/authServices";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";


function Parametre() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const { actualPassword, newPassword, confirmPassword} = data;
    if(newPassword === confirmPassword){
      UpdatePassword(newPassword)
    }else{
      toast.error("Mots de passe ne correspond pas");
    }
    reset();
  }

  return (
    <div className="parametre">
      <div className="" style={{ background: "#FFF", width: "70%" }}>
        <Container>
          <Row>
            <Col>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Actuel mot de passe</Form.Label>
                  <Form.Control {...register("actualPassword")} type="password" placeholder="Entrer l'actuel mot de passe" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Nouveau mot de passe</Form.Label>
                  <Form.Control {...register("newPassword")} type="password" placeholder="Entrer le nouveau mot de passe" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Confirmation mot de passe</Form.Label>
                  <Form.Control {...register("confirmPassword")} type="password" placeholder="Confirmer le nouveau mot de passe !" />
                </Form.Group>

                <Button variant="primary" type="submit">
                  SAVE CHANGES
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Parametre;
